import { Ctx } from '.';

export function hasRole(user: User | undefined, role: User['role']): boolean {
  return user?.role === role;
}

export function isAdmin({ user }: Ctx): boolean {
  return hasRole(user, 'admin');
}

export function isCurator({ user }: Ctx): boolean {
  return hasRole(user, 'curator');
}

export function isBanned({ user }: Ctx): boolean {
  return hasRole(user, 'banned');
}

export function isOwner({ user, resource }: Ctx<GalleryImage>): boolean {
  // @ts-expect-error
  return !!user && resource?.user?.id === user.id;
}
